__webpack_require__.p = "https://ts-website-project-sample.uat.sennder.com/";